import { render } from "./ResourcesSection.vue?vue&type=template&id=5fabf5d8&scoped=true"
import script from "./ResourcesSection.vue?vue&type=script&lang=js"
export * from "./ResourcesSection.vue?vue&type=script&lang=js"

import "./ResourcesSection.vue?vue&type=style&index=0&id=5fabf5d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fabf5d8"]])

export default __exports__